<template>
    <div class="web-box-all">
      <ext-header select_menu="9"></ext-header>

      <div class="web-home-main">

        <div class="web-order-box">
          <div class="web-order-left">
            <ext-nav></ext-nav>
          </div>
          <div class="web-order-right">

            <div class="web-user-title">
              <p><i></i>我的弗兰卡 > 我的账单</p>
            </div>

            <div class="web-integral-top">
                <div class="block" style="margin-top:25px;">
                    <span class="demonstration" style="line-height:30px;">选择月份：</span>
                    <el-date-picker
                        size="small"
                        v-model="select_value"
                        type="monthrange"
                        range-separator="至"
                        start-placeholder="开始月份"
                        end-placeholder="结束月份"
                        value-format="yyyy-MM"
                        @change="select_month_even"
                        >
                    </el-date-picker>
                </div>
            </div>

            <div class="web-integral-list">

              <h2>
                <a style="width:60%;">日期范围</a>
                <a>金额</a>
                <a>操作</a>
              </h2>

              <p v-for="(vo,index) in list_data" :key="index">
                <a style="width:60%;">{{vo.select_date}}</a>
                <a>{{vo.sum_fee}}</a>
                <a @click="openLink(vo.select_date)" style="cursor: pointer;">查看订单</a>
              </p>

            </div>
          </div>
        </div>

      </div>

      <div class="web-home-line"></div>

      <ext-footer></ext-footer>

    </div>
  </template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import ExtNav from '@/components/leftnav/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'
import { copyFile } from 'fs'

export default {
  name: 'integral',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-nav': ExtNav
  },
  data () {
    return {
      title: '餐厅账单',
      toast_state: 'display:none',
      toast_text: '',
      select_month: '',
      select_value: '',
      list_data: []
    }
  },
  mounted () {
    this.load_data()
  },
  methods: {
    select_month_even (el) {
      this.select_month = el['0'] + ',' + el['1']
      this.select_value = el
      this.load_data()
    },
    load_data () {
      var that = this
      ajax({
        url: '/store/home/month_fee_json',
        method: 'post',
        data: {
          uid: getUserId(),
          select_month: that.select_month
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.list_data = ret.data
        } else {
          that.list_data = []
        }
      })
    },
    openLink (selectDate) {
      if (selectDate) {
        var array = selectDate.split(' 至 ')
        if (array.length > 1) {
          var url = this.$router.resolve({path: '/order/order_list', query: {start_date: array['0'], end_date: array['1']}})
          window.open(url.href, '_blank')
        }
      }
    }
  }
}
</script>
  <style scoped>
  header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
      display:-moz-box;
      display: box;
      display: -webkit-box;
      font-family: "Noto Sans SC";
      display: inline-flex;
  }

  a { text-decoration:none; }
  input { box-sizing:border-box;outline:none;}
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {-webkit-appearance: none;}
  input[type='number'] {-moz-appearance: textfield;}

  .web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
  .web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
  .web-home-line { width:100%; height:70px; }

  .web-order-box { width:100%; height:auto; flex-flow:row; align-content:flex-start; margin-top:20px;}
    .web-order-left { width:200px; height:auto; margin-right:15px; flex-wrap:wrap; align-content:flex-start;}

    .web-order-right { width:785px; height:auto; flex-wrap:wrap; align-content:flex-start;}

      .web-user-title { width:100%; height:40px; flex-flow:row; align-content:flex-start;}
        .web-user-title p { width:auto; height:40px; position: relative; padding:0px 20px; line-height:40px; font-size:14px; color:#333333;}
        .web-user-title p i { width:2px; height:20px; float: left; background: #d81e06; position: absolute; top:10px; left:10px;}

  .web-integral-top { width:100%; height:80px; margin-top:15px; position: relative; border:1px solid #dfdfdf; padding:0px 15px;}
    .web-integral-top p  { width:100%; height:50px; margin-top:15px; padding:0px; line-height:50px; font-size:18px;}

    .web-integral-top h2  {  width:100px; height:30px; position: absolute;  top:15px; right:5px;}

  .web-integral-list { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start; border:1px solid #dfdfdf; margin-top:15px;}
    .web-integral-list h2 {  width:100%; height:40px; line-height:40px; margin:0px; padding:0px 15px; background: #f5f8fa; flex-flow:row; align-content:flex-start;}
    .web-integral-list h2 a { width:20%; height:40px; line-height:40px; font-size:14px; color:#333333;}
    .web-integral-list p { width:100%; height:auto; margin:0px; border-top: 1px solid #efefef; padding:0px 15px; flex-flow:row; align-content:flex-start;}
    .web-integral-list p a { width:20%; height:40px; line-height:40px; font-size:14px; color:#333333;}

      .web-order-list-page { width:100%; height:40px; margin-top:20px;}

      .lemon-page { color:#333333; font-size:14px; height:24px; line-height:24px;}
      .lemon-page-now { background: #d81e06 !important; color:#ffffff !important; width:24px; height:24px;}
      .lemon-page-line { color:#333333; font-style: normal;}
  </style>
  <style>
    .page-item.active .page-link { border:1px solid #d81e06;background: #d81e06 !important; color:#ffffff !important;}
    .el-date-editor .el-range-separator { padding:0px !important;}
    .el-range-editor--small .el-range-separator  { padding:0px !important;}
    .el-range-separator  { padding:0px !important;}
  </style>



// WEBPACK FOOTER //
// src/pages/store/store_bill.vue